






import { Component, Vue } from 'vue-property-decorator';

@Component({ name: 'FormHeader' })
export default class FormHeader extends Vue {}
